import { render } from "./SelectProjectForPackages.vue?vue&type=template&id=4ba6d516&scoped=true"
import script from "./SelectProjectForPackages.vue?vue&type=script&lang=js"
export * from "./SelectProjectForPackages.vue?vue&type=script&lang=js"

import "./SelectProjectForPackages.vue?vue&type=style&index=0&id=4ba6d516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba6d516"]])

export default __exports__